// extracted by mini-css-extract-plugin
module.exports = {"shoppingCartBody":"shoppingCart_shoppingCartBody__Nl96V"};